import React, { useState, useContext } from "react";
import AnimationPopup from "../RenderCompnent/AnimationPopup";
import { PropertyContext } from "../../../contexts/PropertyContext";

const SectionProperties = ({ selectedSection, handleChange, searchTerm }) => {
  const [isAnimationPopupOpen, setIsAnimationPopupOpen] = useState(false);
  const {
    renderMarginProperties,
    renderPaddingProperties,
    renderBorderProperties,
    renderPositionProperties,
    renderHoveredMarginProperties,
    renderFocusedMarginProperties,
    renderActivatedMarginProperties,
    renderHoveredPaddingProperties,
    renderFocusedPaddingProperties,
    renderActivatedPaddingProperties,
    renderHoveredBorderProperties,
    renderFocusedBorderProperties,
    renderActivatedBorderProperties,
    renderHoveredPositionProperties,
    renderFocusedPositionProperties,
    renderActivatedPositionProperties,
    renderBackgroundProperties,
    renderhoveredBackgroundProperties,
    renderactivatedBackgroundProperties,
    renderFocusedBackgroundProperties,
    renderGradientProperties,
    renderHoveredGradientProperties,
    renderFocusedGradientProperties,
    renderActivatedGradientProperties,
  } = useContext(PropertyContext);


  const renderAnimationButton = () => {
    if (searchTerm && !"animation".includes(searchTerm.toLowerCase())) {
      return null;
    }
    return (
      <div style={styles.inputGroup}>
        <button
          onClick={() => setIsAnimationPopupOpen(true)}
          style={styles.animationButton}
        >
          Open Animation Editor
        </button>
      </div>
    );
  };
  const renderInput = (label, name, type = "text", additionalProps = {}) => {
    if (searchTerm && !label.toLowerCase().includes(searchTerm.toLowerCase())) {
      return null;
    }
    return (
      <div style={styles.inputGroup}>
        <label style={styles.label}>{label}: </label>
        <input
          type={type}
          name={name}
          value={selectedSection ? selectedSection[name] : ""}
          onChange={handleChange}
          style={styles.input}
          {...additionalProps}
        />
      </div>
    );
  };
  const renderSelect = (label, name, options) => {
    if (searchTerm && !label.toLowerCase().includes(searchTerm.toLowerCase())) {
      return null;
    }
    return (
      <div key={name} style={styles.inputGroup}>
        <label style={styles.label}>{label}: </label>
        <select
          name={name}
          value={selectedSection ? selectedSection[name] : ""}
          onChange={handleChange}
          style={styles.select}
        >
          <option value="">Select</option>
          {options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    );
  };
  const renderMutableInput = (label, name, array) => {
    if (searchTerm && !label.toLowerCase().includes(searchTerm.toLowerCase())) {
      return null;
    }
    return (
      <div key={name} style={styles.inputGroup}>
        <label style={styles.label}>{label}: </label>
        <div style={styles.widthHeightInputGroup}>
          <select
            name={name}
            value={selectedSection ? selectedSection[name] : ""}
            onChange={handleChange}
            style={styles.select}
          >
            {array.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <input
            type="text"
            name={name}
            value={selectedSection ? selectedSection[name] : ""}
            onChange={handleChange}
            style={styles.input}
          />
        </div>
      </div>
    );
  };

  const allInputs = [
    renderMutableInput("Width", "width", [
      "auto",
      "fit-content",
      "max-content",
      "min-content",
      "100%",
      "100vw",
    ]),
    renderMutableInput("Height", "height", [
      "auto",
      "fit-content",
      "max-content",
      "min-content",
      "100%",
      "100vh",
    ]),
    renderMarginProperties(renderMutableInput),
    renderPaddingProperties(renderMutableInput),
    renderBorderProperties(renderMutableInput, renderInput,renderSelect),
    renderPositionProperties(renderMutableInput, renderInput, renderSelect),

    renderSelect("Box Sizing", "boxSizing", ["content-box", "border-box"]),

    renderSelect("Display", "display", [
      "block",
      "flex",
      "grid",
      "inline",
      "inline-block",
      "inline-flex",
      "inline-grid",
    ]),

    selectedSection && selectedSection.display === "flex" && (
      <>
        {renderSelect("Flex Direction", "flexDirection", [
          "row",
          "row-reverse",
          "column",
          "column-reverse",
        ])}
        {renderSelect("Flex Wrap", "flexWrap", [
          "nowrap",
          "wrap",
          "wrap-reverse",
        ])}
        {renderSelect("Justify Content", "justifyContent", [
          "flex-start",
          "flex-end",
          "center",
          "space-between",
          "space-around",
        ])}
        {renderSelect("Align Items", "alignItems", [
          "stretch",
          "flex-start",
          "flex-end",
          "center",
          "baseline",
        ])}
        {renderSelect("Align Content", "alignContent", [
          "stretch",
          "flex-start",
          "flex-end",
          "center",
          "space-between",
          "space-around",
        ])}
        {renderSelect("Align Self", "alignSelf", [
          "auto",
          "flex-start",
          "flex-end",
          "center",
          "baseline",
          "stretch",
        ])}
        {/* {renderSelect("Place Content", "placeContent", [
          "stretch",
          "flex-start",
          "flex-end",
          "center",
          "space-between",
          "space-around",
        ])}
        {renderSelect("Place Items", "placeItems", [
          "stretch",
          "flex-start",
          "flex-end",
          "center",
          "baseline",
        ])} */}
        {renderInput("Order", "order", "number")}
        {renderInput("Flex Grow", "flexGrow", "number")}
        {renderInput("Flex Shrink", "flexShrink", "number")}
        {renderInput("Flex Basis", "flexBasis", "text", {
          placeholder: "e.g. flex-basis:200px",
        })}
      </>
    ),
    selectedSection && selectedSection.display === "grid" && (
      <>
        {renderMutableInput("Grid Template Columns", "gridTemplateColumns", [
          "1fr 1fr",
          "repeat(2, 1fr)",
          "repeat(3, 1fr)",
          "200px 1fr 2fr",
        ])}
        {renderMutableInput("Grid Template Rows", "gridTemplateRows", [
          "1fr 1fr",
          "repeat(2, 1fr)",
          "repeat(3, 1fr)",
          "200px 1fr 2fr",
        ])}
        {renderInput("Grid Area", "gridArea")}
        {renderSelect("Grid Auto Flow", "gridAutoFlow", [
          "row",
          "column",
          "row dense",
          "column dense",
        ])}
        {renderInput("Grid Auto Columns", "gridAutoColumns")}
        {renderInput("Grid Auto Rows", "gridAutoRows")}
        {renderSelect("Grid Justify Items", "justifyItems", [
          "start",
          "end",
          "center",
          "stretch",
        ])}
        {renderSelect("Grid Justify Content", "justifyContent", [
          "start",
          "end",
          "center",
          "space-between",
          "space-around",
          "stretch",
        ])}
        {renderSelect("Grid Align Content", "alignContent", [
          "start",
          "end",
          "center",
          "space-between",
          "space-around",
          "stretch",
        ])}
        {renderSelect("Grid Place Items", "placeItems", [
          "start",
          "end",
          "center",
          "stretch",
        ])}
        {renderSelect("Grid Place Content", "placeContent", [
          "start",
          "end",
          "center",
          "space-between",
          "space-around",
          "stretch",
        ])}
        {renderInput("Grid Column Gap", "columnGap")}
        {renderInput("Grid Row Gap", "rowGap")}
      </>
    ),

    renderMutableInput("Gap", "gap", ["0", "2rem", "2em", "10px", "2%"]),
    renderSelect("Visibility", "visibility", [
      "visible",
      "hidden",
      "collapse",
      "inherit",
      "initial",
      "unset",
    ]),

    renderInput("Color", "color", "color"),
    renderInput("Background Color", "backgroundColor", "color"),

    renderBackgroundProperties(
      renderSelect,
      searchTerm,
      handleChange,
      selectedSection
    ),
    renderGradientProperties(
      renderSelect,
      searchTerm,
      renderInput,
      selectedSection
    ),

    renderMutableInput("Box Shadow", "boxShadow", [
      "none",
      "2px 4px 10px #000000",
    ]),
    renderInput("Opacity", "opacity", "number", {
      min: 0,
      max: 1,
      step: 0.01,
    }),
    renderMutableInput("Filter", "filter", [
      "none",
      "blur(5px)",
      "brightness(0.5)",
      "contrast(150%)",
      "drop-shadow(10px 10px 5px grey)",
      "grayscale(100%)",
      "hue-rotate(90deg)",
      "invert(100%)",
      "opacity(50%)",
      "saturate(200%)",
      "sepia(100%)",
    ]),
    renderMutableInput("Back-Drop Filter", "backdropFilter", [
      "none",
      "blur(5px)",
      "brightness(0.5)",
      "contrast(150%)",
      "drop-shadow(10px 10px 5px grey)",
      "grayscale(100%)",
      "hue-rotate(90deg)",
      "invert(100%)",
      "opacity(50%)",
      "saturate(200%)",
      "sepia(100%)",
    ]),
    renderMutableInput("Aspect Ratio", "aspectRatio", [
      "auto",
      "1 / 1",
      "4 / 3",
      "16 / 9",
      "21 / 9",
      "3 / 2",
      "8.5 / 11",
      "11 / 8.5",
      "A4",
      "custom",
    ]),

    renderSelect("Mix Blend Mode", "mixBlendMode", [
      "normal",
      "multiply",
      "screen",
      "overlay",
      "darken",
      "lighten",
      "color-dodge",
      "color-burn",
      "hard-light",
      "soft-light",
      "difference",
      "exclusion",
      "hue",
      "saturation",
      "color",
      "luminosity",
    ]),

    renderSelect("Overflow", "overflow", [
      "visible",
      "hidden",
      "scroll",
      "auto",
    ]),
    renderSelect("Overflow-X", "overflowX", [
      "visible",
      "hidden",
      "scroll",
      "auto",
    ]),
    renderSelect("Overflow-Y", "overflowY", [
      "visible",
      "hidden",
      "scroll",
      "auto",
    ]),
    renderSelect("Font Family", "fontFamily", [
      "Arial",
      "Helvetica",
      "Times New Roman",
      "Courier New",
      "Verdana",
      "Georgia",
      "Palatino",
      "Garamond",
      "Comic Sans MS",
      "Trebuchet MS",
      "Arial Black",
      "Impact",
      "Tahoma",
      "Lucida Sans Unicode",
      "Lucida Grande",
      "Century Gothic",
      "Frank Ruhl",
      "Segoe UI",
      "Gill Sans",
      "Myriad Pro",
      "Futura",
      "Baskerville",
      "Didot",
      "Optima",
      "Caslon",
      "Cambria",
      "Consolas",
      "Menlo",
      "Andale Mono",
      "Inconsolata",
      "Source Sans Pro",
      "Roboto",
      "Open Sans",
      "Lato",
      "Montserrat",
      "Raleway",
      "Oswald",
      "Poppins",
      "Merriweather",
      "PT Sans",
      "Playfair Display",
      "Nunito",
      "Rubik",
      "Josefin Sans",
      "Quicksand",
      "Droid Sans",
      "Noto Sans",
      "Exo 2",
      "Work Sans",
      "Overpass",
      "Alegreya",
      "Bebas Neue",
      "Hind",
      "Anton",
      "Lora",
      "DM Sans",
      "Barlow",
      "Titillium Web",
      "Suisse Int'l",
      "Noto Serif",
      "Tisa",
      "Muli",
      "Arimo",
      "Karla",
      "Zilla Slab",
      "Space Mono",
      "Libre Baskerville",
      "Fira Sans",
      "Archivo Narrow",
      "Varela Round",
      "Oxygen",
      "Catamaran",
      "Cairo",
      "Dosis",
      "Kreon",
      "Bitter",
      "Candal",
      "Averia Serif Libre",
      "Arapey",
      "Hind Guntur",
      "Saira",
      "Titillium",
      "Dancing Script",
      "Satisfy",
      "Raleway Dots",
      "Courgette",
      "Lobster",
      "Pacifico",
      "Shadows Into Light",
      "Sacramento",
      "Rock Salt",
      "Yellowtail",
    ]),
    renderMutableInput("Font Size", "fontSize", [
      "16px",
      "2em",
      "1rem",
      "75%",
      "1vw",
    ]),
    renderSelect("Font Weight", "fontWeight", [
      "normal",
      "bold",
      "100",
      "200",
      "300",
      "400",
      "500",
      "600",
      "700",
      "800",
      "900",
    ]),
    renderSelect("Font Style", "fontStyle", ["normal", "italic", "oblique"]),
    renderSelect("Font Variant", "fontVariant", ["normal", "small-caps"]),
    renderInput("Line Height", "lineHeight", "text", {
      placeholder: "e.g., 1.5 or 24px",
    }),
    renderMutableInput("Text Shadow", "textShadow", [
      "none",
      "2px 2px 5px #000000",
    ]),

    renderSelect("Text Align", "textAlign", [
      "left",
      "center",
      "right",
      "justify",
    ]),
    renderSelect("Vertical Align", "verticalAlign", [
      "baseline",
      "sub",
      "super",
      "top",
      "text-top",
      "middle",
      "bottom",
      "text-bottom",
    ]),
    renderSelect("Text Decoration", "textDecoration", [
      "none",
      "underline",
      "overline",
      "line-through",
    ]),
    renderSelect("Text Transform", "textTransform", [
      "none",
      "capitalize",
      "uppercase",
      "lowercase",
    ]),
    renderInput("Letter Spacing", "letterSpacing", "text", {
      placeholder: "e.g., 1px or 0.1em",
    }),
    renderInput("Word Spacing", "wordSpacing", "text", {
      placeholder: "e.g., 2px or 0.5em",
    }),
    renderInput("Text Indent", "textIndent", "text", {
      placeholder: "e.g., 20px or 2em",
    }),
    renderSelect("White Space", "whiteSpace", [
      "normal",
      "nowrap",
      "pre",
      "pre-line",
      "pre-wrap",
    ]),
    renderSelect("Text Overflow", "textOverflow", ["clip", "ellipsis", "fade"]),
    renderSelect("Direction", "direction", ["ltr", "rtl"]),
    renderSelect("Unicode Bidi", "unicodeBidi", [
      "normal",
      "embed",
      "bidi-override",
    ]),
    renderSelect("Writing Mode", "writingMode", [
      "horizontal-tb",
      "vertical-rl",
      "vertical-lr",
    ]),

    renderSelect("Resize", "resize", [
      "none",
      "both",
      "vertical",
      "horizontal",
    ]),
    renderSelect("User Select", "userSelect", ["none", "auto", "text", "all"]),
    renderSelect("Cursor Type", "cursor", [
      "default",
      "pointer",
      "text",
      "move",
      "wait",
      "help",
      "not-allowed",
      "crosshair",
      "cell",
      "vertical-text",
      "alias",
      "copy",
      "no-drop",
      "grab",
      "grabbing",
      "e-resize",
      "n-resize",
      "ne-resize",
      "nw-resize",
      "s-resize",
      "se-resize",
      "sw-resize",
      "w-resize",
      "ns-resize",
      "ew-resize",
      "nesw-resize",
      "nwse-resize",
      "zoom-in",
      "zoom-out",
      "all-scroll",
    ]),

    renderMutableInput("Transform", "transform", [
      "none",
      "translate(100px, 200px)",
      "translateX(100px)",
      "translateY(200px)",
      "scale(1.5, 1.6)",
      "scaleX(1.5)",
      "scaleY(1.6)",
      "rotate(30deg)",
      "skew(30deg, 10deg)",
      "skewX(30deg)",
      "skewY(10deg)",
      "matrix(1, 0.5, -0.5, 1, 100, 200)",
    ]),
    renderMutableInput("Transition Timing Function", "transition", [
      "none",
      "ease 3s",
      "linear 3s",
      "ease-in 3s",
      "ease-out 3s",
      "ease-in-out 3s",
      "cubic-bezier(0.25, 0.1, 0.25, 1.0)",
    ]),

    renderAnimationButton(),
    <AnimationPopup
      isOpen={isAnimationPopupOpen}
      onClose={() => setIsAnimationPopupOpen(false)}
      selectedDiv={selectedSection}
      handleChange={handleChange}
    />,
    renderSelect("Pseudo Classes", "pseudoClass", [
      "none",
      "hover",
      "focus",
      "active",
    ]),
    selectedSection && selectedSection.pseudoClass === "hover" && (
      <>
        {renderMutableInput("Width Hover", "hoveredwidth", [
          "auto",
          "fit-content",
          "max-content",
          "min-content",
          "100%",
          "100vw",
        ])}
        {renderMutableInput("Height Hover", "hoveredheight", [
          "auto",
          "fit-content",
          "max-content",
          "min-content",
          "100%",
          "100vh",
        ])}
        {renderHoveredMarginProperties(renderMutableInput)}
        {renderHoveredPaddingProperties(renderMutableInput)}
        {renderHoveredBorderProperties(renderMutableInput, renderInput,renderSelect)}
        {renderHoveredPositionProperties(
          renderMutableInput,
          renderInput,
          renderSelect
        )}

        {renderMutableInput("Box Shadow Hover", "hoveredboxShadow", [
          "none",
          "2px 4px 10px #000000",
        ])}
        {renderInput("Opacity Hover", "hoveredOpacity", "number", {
          min: 0,
          max: 1,
          step: 0.01,
        })}

        {renderSelect("Display Hover", "hovereddisplay", [
          "block",
          "flex",
          "grid",
          "inline",
          "inline-block",
          "inline-flex",
          "inline-grid",
        ])}
        {selectedSection && selectedSection.hovereddisplay === "flex" && (
          <>
            {renderSelect("Flex Direction Hover", "hoveredflexDirection", [
              "row",
              "row-reverse",
              "column",
              "column-reverse",
            ])}
            {renderSelect("Flex Wrap Hover", "hoveredflexWrap", [
              "nowrap",
              "wrap",
              "wrap-reverse",
            ])}
            {renderSelect("Justify Content Hover", "hoveredjustifyContent", [
              "flex-start",
              "flex-end",
              "center",
              "space-between",
              "space-around",
            ])}
            {renderSelect("Align Items Hover", "hoveredalignItems", [
              "stretch",
              "flex-start",
              "flex-end",
              "center",
              "baseline",
            ])}
            {renderSelect("Align Content Hover", "hoveredalignContent", [
              "stretch",
              "flex-start",
              "flex-end",
              "center",
              "space-between",
              "space-around",
            ])}
            {renderSelect("Align Self Hover", "hoveredalignSelf", [
              "auto",
              "flex-start",
              "flex-end",
              "center",
              "baseline",
              "stretch",
            ])}
            {renderSelect("Place Content Hover", "hoveredplaceContent", [
              "stretch",
              "flex-start",
              "flex-end",
              "center",
              "space-between",
              "space-around",
            ])}
            {renderSelect("Place Items Hover", "hoveredplaceItems", [
              "stretch",
              "flex-start",
              "flex-end",
              "center",
              "baseline",
            ])}
            {renderInput("Order Hover", "hoveredorder", "number")}
            {renderInput("Flex Grow Hover", "hoveredflexGrow", "number")}
            {renderInput("Flex Shrink Hover", "hoveredflexShrink", "number")}
            {renderInput("Flex Basis Hover", "hoveredflexBasis", "text", {
              placeholder: "e.g. flex-basis:200px",
            })}
          </>
        )}
        {selectedSection && selectedSection.hovereddisplay === "grid" && (
          <>
            {renderMutableInput(
              "Grid Template Columns Hover",
              "hoveredgridTemplateColumns",
              ["1fr 1fr", "repeat(2, 1fr)", "repeat(3, 1fr)", "200px 1fr 2fr"]
            )}
            {renderMutableInput(
              "Grid Template Rows Hover",
              "hoveredgridTemplateRows",
              ["1fr 1fr", "repeat(2, 1fr)", "repeat(3, 1fr)", "200px 1fr 2fr"]
            )}
            {renderInput("Grid Area Hover", "hoveredgridArea")}
            {renderSelect("Grid Auto Flow Hover", "hoveredgridAutoFlow", [
              "row",
              "column",
              "row dense",
              "column dense",
            ])}
            {renderInput("Grid Auto Columns Hover", "hoveredgridAutoColumns")}
            {renderInput("Grid Auto Rows Hover", "hoveredgridAutoRows")}
            {renderSelect("Grid Justify Items Hover", "hoveredjustifyItems", [
              "start",
              "end",
              "center",
              "stretch",
            ])}
            {renderSelect(
              "Grid Justify Content Hover",
              "hoveredjustifyContent",
              [
                "start",
                "end",
                "center",
                "space-between",
                "space-around",
                "stretch",
              ]
            )}
            {renderSelect("Grid Align Content Hover", "hoveredalignContent", [
              "start",
              "end",
              "center",
              "space-between",
              "space-around",
              "stretch",
            ])}
            {renderSelect("Grid Place Items Hover", "hoveredplaceItems", [
              "start",
              "end",
              "center",
              "stretch",
            ])}
            {renderSelect("Grid Place Content Hover", "hoveredplaceContent", [
              "start",
              "end",
              "center",
              "space-between",
              "space-around",
              "stretch",
            ])}
            {renderInput("Grid Column Gap Hover", "hoveredcolumnGap")}
            {renderInput("Grid Row Gap Hover", "hoveredrowGap")}
          </>
        )}
        {renderMutableInput("Gap Hover", "hoveredgap", [
          "0",
          "2rem",
          "2em",
          "10px",
          "2%",
        ])}
        {renderSelect("Visibility Hover", "hoveredvisibility", [
          "visible",
          "hidden",
          "collapse",
          "inherit",
          "initial",
          "unset",
        ])}

        {renderInput("Color Hover", "hoveredcolor", "color")}
        {renderInput(
          "Background Color Hover",
          "hoveredbackgroundColor",
          "color"
        )}
        {renderhoveredBackgroundProperties(
          renderSelect,
          searchTerm,
          handleChange,
          selectedSection
        )}
        {renderHoveredGradientProperties(
          renderSelect,
          searchTerm,
          renderInput,
          selectedSection
        )}

        {renderSelect("Font Family Hover", "hoveredfontFamily", [
          "Arial",
          "Helvetica",
          "Times New Roman",
          "Courier New",
          "Verdana",
          "Georgia",
          "Palatino",
          "Garamond",
          "Comic Sans MS",
          "Trebuchet MS",
          "Arial Black",
          "Impact",
          "Tahoma",
          "Lucida Sans Unicode",
          "Lucida Grande",
          "Century Gothic",
          "Frank Ruhl",
          "Segoe UI",
          "Gill Sans",
          "Myriad Pro",
          "Futura",
          "Baskerville",
          "Didot",
          "Optima",
          "Caslon",
          "Cambria",
          "Consolas",
          "Menlo",
          "Andale Mono",
          "Inconsolata",
          "Source Sans Pro",
          "Roboto",
          "Open Sans",
          "Lato",
          "Montserrat",
          "Raleway",
          "Oswald",
          "Poppins",
          "Merriweather",
          "PT Sans",
          "Playfair Display",
          "Nunito",
          "Rubik",
          "Josefin Sans",
          "Quicksand",
          "Droid Sans",
          "Noto Sans",
          "Exo 2",
          "Work Sans",
          "Overpass",
          "Alegreya",
          "Bebas Neue",
          "Hind",
          "Anton",
          "Lora",
          "DM Sans",
          "Barlow",
          "Titillium Web",
          "Suisse Int'l",
          "Noto Serif",
          "Tisa",
          "Muli",
          "Arimo",
          "Karla",
          "Zilla Slab",
          "Space Mono",
          "Libre Baskerville",
          "Fira Sans",
          "Archivo Narrow",
          "Varela Round",
          "Oxygen",
          "Catamaran",
          "Cairo",
          "Dosis",
          "Kreon",
          "Bitter",
          "Candal",
          "Averia Serif Libre",
          "Arapey",
          "Hind Guntur",
          "Saira",
          "Titillium",
          "Dancing Script",
          "Satisfy",
          "Raleway Dots",
          "Courgette",
          "Lobster",
          "Pacifico",
          "Shadows Into Light",
          "Sacramento",
          "Rock Salt",
          "Yellowtail",
        ])}
        {renderMutableInput("Font Size Hover", "hoveredfontSize", [
          "16px",
          "2em",
          "1rem",
          "75%",
          "1vw",
        ])}
        {renderSelect("Font Weight Hover", "hoveredfontWeight", [
          "normal",
          "bold",
          "100",
          "200",
          "300",
          "400",
          "500",
          "600",
          "700",
          "800",
          "900",
        ])}
        {renderSelect("Font Style Hover", "hoveredfontStyle", [
          "normal",
          "italic",
          "oblique",
        ])}
        {renderSelect("Font Variant Hover", "hoveredfontVariant", [
          "normal",
          "small-caps",
        ])}
        {renderInput("Line Height Hover", "hoveredlineHeight", "text", {
          placeholder: "e.g., 1.5 or 24px",
        })}
        {renderMutableInput("Text Shadow Hover", "hoveredtextShadow", [
          "none",
          "2px 2px 5px #000000",
        ])}

        {renderSelect("Text Align Hover", "hoveredtextAlign", [
          "left",
          "center",
          "right",
          "justify",
        ])}
        {renderSelect("Vertical Align Hover", "hoveredverticalAlign", [
          "baseline",
          "sub",
          "super",
          "top",
          "text-top",
          "middle",
          "bottom",
          "text-bottom",
        ])}
        {renderSelect("Text Decoration Hover", "hoveredtextDecoration", [
          "none",
          "underline",
          "overline",
          "line-through",
          "underline overline",
        ])}
        {renderSelect("Text Transform Hover", "hoveredtextTransform", [
          "none",
          "capitalize",
          "uppercase",
          "lowercase",
        ])}
        {renderInput("Letter Spacing Hover", "hoveredletterSpacing", "text", {
          placeholder: "e.g., 1px or 0.1em",
        })}
        {renderInput("Word Spacing Hover", "hoveredwordSpacing", "text", {
          placeholder: "e.g., 2px or 0.5em",
        })}
        {renderInput("Text Indent Hover", "hoveredtextIndent", "text", {
          placeholder: "e.g., 20px or 2em",
        })}
        {renderSelect("White Space Hover", "hoveredwhiteSpace", [
          "normal",
          "nowrap",
          "pre",
          "pre-line",
          "pre-wrap",
        ])}
        {renderSelect("Text Overflow Hover", "hoveredtextOverflow", [
          "clip",
          "ellipsis",
          "fade",
        ])}
        {renderSelect("Direction Hover", "hovereddirection", ["ltr", "rtl"])}
        {renderSelect("Unicode Bidi Hover", "hoveredunicodeBidi", [
          "normal",
          "embed",
          "bidi-override",
        ])}
        {renderSelect("Writing Mode Hover", "hoveredwritingMode", [
          "horizontal-tb",
          "vertical-rl",
          "vertical-lr",
        ])}

        {renderSelect("Cursor Hover", "hoveredcursor", [
          "default",
          "pointer",
          "text",
          "move",
          "wait",
          "help",
          "not-allowed",
          "crosshair",
          "cell",
          "vertical-text",
          "alias",
          "copy",
          "no-drop",
          "grab",
          "grabbing",
          "e-resize",
          "n-resize",
          "ne-resize",
          "nw-resize",
          "s-resize",
          "se-resize",
          "sw-resize",
          "w-resize",
          "ns-resize",
          "ew-resize",
          "nesw-resize",
          "nwse-resize",
          "zoom-in",
          "zoom-out",
          "all-scroll",
        ])}
        {renderMutableInput("Filter Hover", "hoveredfilter", [
          "none",
          "blur(5px)",
          "brightness(0.5)",
          "contrast(150%)",
          "drop-shadow(10px 10px 5px grey)",
          "grayscale(100%)",
          "hue-rotate(90deg)",
          "invert(100%)",
          "opacity(50%)",
          "saturate(200%)",
          "sepia(100%)",
        ])}
        {renderMutableInput("Backdrop Filter Hover", "hoveredbackdropFilter", [
          "none",
          "blur(5px)",
          "brightness(0.5)",
          "contrast(150%)",
          "drop-shadow(10px 10px 5px grey)",
          "grayscale(100%)",
          "hue-rotate(90deg)",
          "invert(100%)",
          "opacity(50%)",
          "saturate(200%)",
          "sepia(100%)",
        ])}
        {renderSelect("Mix Blend Mode Hover", "hoveredmixBlendMode", [
          "normal",
          "multiply",
          "screen",
          "overlay",
          "darken",
          "lighten",
          "color-dodge",
          "color-burn",
          "hard-light",
          "soft-light",
          "difference",
          "exclusion",
          "hue",
          "saturation",
          "color",
          "luminosity",
        ])}
        {renderMutableInput("Aspect Ratio Hover", "hoveredaspectRatio", [
          "auto",
          "1 / 1",
          "4 / 3",
          "16 / 9",
          "21 / 9",
          "3 / 2",
          "8.5 / 11",
          "11 / 8.5",
          "A4",
          "custom",
        ])}

        {renderMutableInput("Transform Hover", "hoveredtransform", [
          "none",
          "translate(100px, 200px)",
          "translateX(100px)",
          "translateY(200px)",
          "scale(1.5, 1.6)",
          "scaleX(1.5)",
          "scaleY(1.6)",
          "rotate(30deg)",
          "skew(30deg, 10deg)",
          "skewX(30deg)",
          "skewY(10deg)",
          "matrix(1, 0.5, -0.5, 1, 100, 200)",
        ])}
        {renderMutableInput("Transition Timing Function", "hoveredtransition", [
          "none",
          "ease 3s",
          "linear 3s",
          "ease-in 3s",
          "ease-out 3s",
          "ease-in-out 3s",
          "cubic-bezier(0.25, 0.1, 0.25, 1.0)",
        ])}
      </>
    ),
    selectedSection && selectedSection.pseudoClass === "focus" && (
      <>
        {renderMutableInput("Width Focus", "focusedwidth", [
          "auto",
          "fit-content",
          "max-content",
          "min-content",
          "100%",
          "100vw",
        ])}
        {renderMutableInput("Height Focus", "focusedheight", [
          "auto",
          "fit-content",
          "max-content",
          "min-content",
          "100%",
          "100vh",
        ])}
        {renderFocusedMarginProperties(renderMutableInput)}
        {renderFocusedPaddingProperties(renderMutableInput)}
        {renderFocusedBorderProperties(renderMutableInput, renderInput,renderSelect)}
        {renderFocusedPositionProperties(
          renderMutableInput,
          renderInput,
          renderSelect
        )}

        {renderMutableInput("Box Shadow Focus", "focusedboxShadow", [
          "none",
          "2px 4px 10px #000000",
        ])}
        {renderInput("Opacity Focus", "focusedOpacity", "number", {
          min: 0,
          max: 1,
          step: 0.01,
        })}

        {renderSelect("Display Focus", "focuseddisplay", [
          "block",
          "flex",
          "grid",
          "inline",
          "inline-block",
          "inline-flex",
          "inline-grid",
        ])}
        {selectedSection && selectedSection.focuseddisplay === "flex" && (
          <>
            {renderSelect("Flex Direction Focus", "focusedflexDirection", [
              "row",
              "row-reverse",
              "column",
              "column-reverse",
            ])}
            {renderSelect("Flex Wrap Focus", "focusedflexWrap", [
              "nowrap",
              "wrap",
              "wrap-reverse",
            ])}
            {renderSelect("Justify Content Focus", "focusedjustifyContent", [
              "flex-start",
              "flex-end",
              "center",
              "space-between",
              "space-around",
            ])}
            {renderSelect("Align Items Focus", "focusedalignItems", [
              "stretch",
              "flex-start",
              "flex-end",
              "center",
              "baseline",
            ])}
            {renderSelect("Align Content Focus", "focusedalignContent", [
              "stretch",
              "flex-start",
              "flex-end",
              "center",
              "space-between",
              "space-around",
            ])}
            {renderSelect("Align Self Focus", "focusedalignSelf", [
              "auto",
              "flex-start",
              "flex-end",
              "center",
              "baseline",
              "stretch",
            ])}
            {renderSelect("Place Content Focus", "focusedplaceContent", [
              "stretch",
              "flex-start",
              "flex-end",
              "center",
              "space-between",
              "space-around",
            ])}
            {renderSelect("Place Items Focus", "focusedplaceItems", [
              "stretch",
              "flex-start",
              "flex-end",
              "center",
              "baseline",
            ])}
            {renderInput("Order Focus", "focusedorder", "number")}
            {renderInput("Flex Grow Focus", "focusedflexGrow", "number")}
            {renderInput("Flex Shrink Focus", "focusedflexShrink", "number")}
            {renderInput("Flex Basis Focus", "focusedflexBasis", "text", {
              placeholder: "e.g. flex-basis:200px",
            })}
          </>
        )}
        {selectedSection && selectedSection.focuseddisplay === "grid" && (
          <>
            {renderMutableInput(
              "Grid Template Columns Focus",
              "focusedgridTemplateColumns",
              ["1fr 1fr", "repeat(2, 1fr)", "repeat(3, 1fr)", "200px 1fr 2fr"]
            )}
            {renderMutableInput(
              "Grid Template Rows Focus",
              "focusedgridTemplateRows",
              ["1fr 1fr", "repeat(2, 1fr)", "repeat(3, 1fr)", "200px 1fr 2fr"]
            )}
            {renderInput("Grid Area Focus", "focusedgridArea")}
            {renderSelect("Grid Auto Flow Focus", "focusedgridAutoFlow", [
              "row",
              "column",
              "row dense",
              "column dense",
            ])}
            {renderInput("Grid Auto Columns Focus", "focusedgridAutoColumns")}
            {renderInput("Grid Auto Rows Focus", "focusedgridAutoRows")}
            {renderSelect("Grid Justify Items Focus", "focusedjustifyItems", [
              "start",
              "end",
              "center",
              "stretch",
            ])}
            {renderSelect(
              "Grid Justify Content Focus",
              "focusedjustifyContent",
              [
                "start",
                "end",
                "center",
                "space-between",
                "space-around",
                "stretch",
              ]
            )}
            {renderSelect("Grid Align Content Focus", "focusedalignContent", [
              "start",
              "end",
              "center",
              "space-between",
              "space-around",
              "stretch",
            ])}
            {renderSelect("Grid Place Items Focus", "focusedplaceItems", [
              "start",
              "end",
              "center",
              "stretch",
            ])}
            {renderSelect("Grid Place Content Focus", "focusedplaceContent", [
              "start",
              "end",
              "center",
              "space-between",
              "space-around",
              "stretch",
            ])}
            {renderInput("Grid Column Gap Focus", "focusedcolumnGap")}
            {renderInput("Grid Row Gap Focus", "focusedrowGap")}
          </>
        )}
        {renderMutableInput("Gap Focus", "focusedgap", [
          "0",
          "2rem",
          "2em",
          "10px",
          "2%",
        ])}
        {renderSelect("Visibility Focus", "focusedvisibility", [
          "visible",
          "hidden",
          "collapse",
          "inherit",
          "initial",
          "unset",
        ])}

        {renderInput("Color Focus", "focusedcolor", "color")}
        {renderInput(
          "Background Color Focus",
          "focusedbackgroundColor",
          "color"
        )}
        {renderFocusedBackgroundProperties(
          renderSelect,
          searchTerm,
          handleChange,
          selectedSection
        )}
        {renderFocusedGradientProperties(
          renderSelect,
          searchTerm,
          renderInput,
          selectedSection
        )}

        {renderSelect("Font Family Focus", "focusedfontFamily", [
          "Arial",
          "Helvetica",
          "Times New Roman",
          "Courier New",
          "Verdana",
          "Georgia",
          "Palatino",
          "Garamond",
          "Comic Sans MS",
          "Trebuchet MS",
          "Arial Black",
          "Impact",
          "Tahoma",
          "Lucida Sans Unicode",
          "Lucida Grande",
          "Century Gothic",
          "Frank Ruhl",
          "Segoe UI",
          "Gill Sans",
          "Myriad Pro",
          "Futura",
          "Baskerville",
          "Didot",
          "Optima",
          "Caslon",
          "Cambria",
          "Consolas",
          "Menlo",
          "Andale Mono",
          "Inconsolata",
          "Source Sans Pro",
          "Roboto",
          "Open Sans",
          "Lato",
          "Montserrat",
          "Raleway",
          "Oswald",
          "Poppins",
          "Merriweather",
          "PT Sans",
          "Playfair Display",
          "Nunito",
          "Rubik",
          "Josefin Sans",
          "Quicksand",
          "Droid Sans",
          "Noto Sans",
          "Exo 2",
          "Work Sans",
          "Overpass",
          "Alegreya",
          "Bebas Neue",
          "Hind",
          "Anton",
          "Lora",
          "DM Sans",
          "Barlow",
          "Titillium Web",
          "Suisse Int'l",
          "Noto Serif",
          "Tisa",
          "Muli",
          "Arimo",
          "Karla",
          "Zilla Slab",
          "Space Mono",
          "Libre Baskerville",
          "Fira Sans",
          "Archivo Narrow",
          "Varela Round",
          "Oxygen",
          "Catamaran",
          "Cairo",
          "Dosis",
          "Kreon",
          "Bitter",
          "Candal",
          "Averia Serif Libre",
          "Arapey",
          "Hind Guntur",
          "Saira",
          "Titillium",
          "Dancing Script",
          "Satisfy",
          "Raleway Dots",
          "Courgette",
          "Lobster",
          "Pacifico",
          "Shadows Into Light",
          "Sacramento",
          "Rock Salt",
          "Yellowtail",
        ])}
        {renderMutableInput("Font Size Focus", "focusedfontSize", [
          "16px",
          "2em",
          "1rem",
          "75%",
          "1vw",
        ])}
        {renderSelect("Font Weight Focus", "focusedfontWeight", [
          "normal",
          "bold",
          "100",
          "200",
          "300",
          "400",
          "500",
          "600",
          "700",
          "800",
          "900",
        ])}
        {renderSelect("Font Style Focus", "focusedfontStyle", [
          "normal",
          "italic",
          "oblique",
        ])}
        {renderSelect("Font Variant Focus", "focusedfontVariant", [
          "normal",
          "small-caps",
        ])}
        {renderInput("Line Height Focus", "focusedlineHeight", "text", {
          placeholder: "e.g., 1.5 or 24px",
        })}
        {renderMutableInput("Text Shadow Focus", "focusedtextShadow", [
          "none",
          "2px 2px 5px #000000",
        ])}

        {renderSelect("Text Align Focus", "focusedtextAlign", [
          "left",
          "center",
          "right",
          "justify",
        ])}
        {renderSelect("Vertical Align Focus", "focusedverticalAlign", [
          "baseline",
          "sub",
          "super",
          "top",
          "text-top",
          "middle",
          "bottom",
          "text-bottom",
        ])}
        {renderSelect("Text Decoration Focus", "focusedtextDecoration", [
          "none",
          "underline",
          "overline",
          "line-through",
          "underline overline",
        ])}
        {renderSelect("Text Transform Focus", "focusedtextTransform", [
          "none",
          "capitalize",
          "uppercase",
          "lowercase",
        ])}
        {renderInput("Letter Spacing Focus", "focusedletterSpacing", "text", {
          placeholder: "e.g., 1px or 0.1em",
        })}
        {renderInput("Word Spacing Focus", "focusedwordSpacing", "text", {
          placeholder: "e.g., 2px or 0.5em",
        })}
        {renderInput("Text Indent Focus", "focusedtextIndent", "text", {
          placeholder: "e.g., 20px or 2em",
        })}
        {renderSelect("White Space Focus", "focusedwhiteSpace", [
          "normal",
          "nowrap",
          "pre",
          "pre-line",
          "pre-wrap",
        ])}
        {renderSelect("Text Overflow Focus", "focusedtextOverflow", [
          "clip",
          "ellipsis",
          "fade",
        ])}
        {renderSelect("Direction Focus", "focuseddirection", ["ltr", "rtl"])}
        {renderSelect("Unicode Bidi Focus", "focusedunicodeBidi", [
          "normal",
          "embed",
          "bidi-override",
        ])}
        {renderSelect("Writing Mode Focus", "focusedwritingMode", [
          "horizontal-tb",
          "vertical-rl",
          "vertical-lr",
        ])}

        {renderSelect("Cursor Focus", "focusedcursor", [
          "default",
          "pointer",
          "text",
          "move",
          "wait",
          "help",
          "not-allowed",
          "crosshair",
          "cell",
          "vertical-text",
          "alias",
          "copy",
          "no-drop",
          "grab",
          "grabbing",
          "e-resize",
          "n-resize",
          "ne-resize",
          "nw-resize",
          "s-resize",
          "se-resize",
          "sw-resize",
          "w-resize",
          "ns-resize",
          "ew-resize",
          "nesw-resize",
          "nwse-resize",
          "zoom-in",
          "zoom-out",
          "all-scroll",
        ])}
        {renderSelect("Filter Focus", "focusedfilter", [
          "none",
          "blur(5px)",
          "brightness(0.5)",
          "contrast(150%)",
          "drop-shadow(10px 10px 5px grey)",
          "grayscale(100%)",
          "hue-rotate(90deg)",
          "invert(100%)",
          "opacity(50%)",
          "saturate(200%)",
          "sepia(100%)",
        ])}
        {renderSelect("Backdrop Filter Focus", "focusedbackdropFilter", [
          "none",
          "blur(5px)",
          "brightness(0.5)",
          "contrast(150%)",
          "drop-shadow(10px 10px 5px grey)",
          "grayscale(100%)",
          "hue-rotate(90deg)",
          "invert(100%)",
          "opacity(50%)",
          "saturate(200%)",
          "sepia(100%)",
        ])}
        {renderSelect("Mix Blend Mode Focus", "focusedmixBlendMode", [
          "normal",
          "multiply",
          "screen",
          "overlay",
          "darken",
          "lighten",
          "color-dodge",
          "color-burn",
          "hard-light",
          "soft-light",
          "difference",
          "exclusion",
          "hue",
          "saturation",
          "color",
          "luminosity",
        ])}
        {renderMutableInput("Aspect Ratio Focus", "FocusedaspectRatio", [
          "auto",
          "1 / 1",
          "4 / 3",
          "16 / 9",
          "21 / 9",
          "3 / 2",
          "8.5 / 11",
          "11 / 8.5",
          "A4",
          "custom",
        ])}

        {renderMutableInput("Transform Focus", "focusedtransform", [
          "none",
          "translate(100px, 200px)",
          "translateX(100px)",
          "translateY(200px)",
          "scale(1.5, 1.6)",
          "scaleX(1.5)",
          "scaleY(1.6)",
          "rotate(30deg)",
          "skew(30deg, 10deg)",
          "skewX(30deg)",
          "skewY(10deg)",
          "matrix(1, 0.5, -0.5, 1, 100, 200)",
        ])}
        {renderMutableInput(
          "Transition Timing Function Focus",
          "focusedtransition",
          [
            "none",
            "ease 3s",
            "linear 3s",
            "ease-in 3s",
            "ease-out 3s",
            "ease-in-out 3s",
            "cubic-bezier(0.25, 0.1, 0.25, 1.0)",
          ]
        )}
      </>
    ),
    selectedSection && selectedSection.pseudoClass === "active" && (
      <>
        {renderMutableInput("Width Active", "activatedwidth", [
          "auto",
          "fit-content",
          "max-content",
          "min-content",
          "100%",
          "100vw",
        ])}
        {renderMutableInput("Height Active", "activatedheight", [
          "auto",
          "fit-content",
          "max-content",
          "min-content",
          "100%",
          "100vh",
        ])}
        {renderActivatedMarginProperties(renderMutableInput)}
        {renderActivatedPaddingProperties(renderMutableInput)}
        {renderActivatedBorderProperties(renderMutableInput, renderInput,renderSelect)}
        {renderActivatedPositionProperties(
          renderMutableInput,
          renderInput,
          renderSelect
        )}
        {renderMutableInput("Box Shadow Active", "activatedboxShadow", [
          "none",
          "2px 4px 10px #000000",
        ])}
        {renderInput("Opacity Active", "activatedOpacity", "number", {
          min: 0,
          max: 1,
          step: 0.01,
        })}

        {renderSelect("Display Activate", "activateddisplay", [
          "block",
          "flex",
          "grid",
          "inline",
          "inline-block",
          "inline-flex",
          "inline-grid",
        ])}
        {selectedSection && selectedSection.activateddisplay === "flex" && (
          <>
            {renderSelect("Flex Direction Active", "activatedflexDirection", [
              "row",
              "row-reverse",
              "column",
              "column-reverse",
            ])}
            {renderSelect("Flex Wrap Active", "activatedflexWrap", [
              "nowrap",
              "wrap",
              "wrap-reverse",
            ])}
            {renderSelect("Justify Content Active", "activatedjustifyContent", [
              "flex-start",
              "flex-end",
              "center",
              "space-between",
              "space-around",
            ])}
            {renderSelect("Align Items Active", "activatedalignItems", [
              "stretch",
              "flex-start",
              "flex-end",
              "center",
              "baseline",
            ])}
            {renderSelect("Align Content Active", "activatedalignContent", [
              "stretch",
              "flex-start",
              "flex-end",
              "center",
              "space-between",
              "space-around",
            ])}
            {renderSelect("Align Self Active", "activatedalignSelf", [
              "auto",
              "flex-start",
              "flex-end",
              "center",
              "baseline",
              "stretch",
            ])}
            {renderSelect("Place Content Active", "activatedplaceContent", [
              "stretch",
              "flex-start",
              "flex-end",
              "center",
              "space-between",
              "space-around",
            ])}
            {renderSelect("Place Items Active", "activatedplaceItems", [
              "stretch",
              "flex-start",
              "flex-end",
              "center",
              "baseline",
            ])}
            {renderInput("Order Active", "activatedorder", "number")}
            {renderInput("Flex Grow Active", "activatedflexGrow", "number")}
            {renderInput("Flex Shrink Active", "activatedflexShrink", "number")}
            {renderInput("Flex Basis Active", "activatedflexBasis", "text", {
              placeholder: "e.g. flex-basis:200px",
            })}
          </>
        )}
        {selectedSection && selectedSection.activateddisplay === "grid" && (
          <>
            {renderMutableInput(
              "Grid Template Columns Active",
              "activatedgridTemplateColumns",
              ["1fr 1fr", "repeat(2, 1fr)", "repeat(3, 1fr)", "200px 1fr 2fr"]
            )}
            {renderMutableInput(
              "Grid Template Rows Active",
              "activatedgridTemplateRows",
              ["1fr 1fr", "repeat(2, 1fr)", "repeat(3, 1fr)", "200px 1fr 2fr"]
            )}
            {renderInput("Grid Area Active", "activatedgridArea")}
            {renderSelect("Grid Auto Flow Active", "activatedgridAutoFlow", [
              "row",
              "column",
              "row dense",
              "column dense",
            ])}
            {renderInput(
              "Grid Auto Columns Active",
              "activatedgridAutoColumns"
            )}
            {renderInput("Grid Auto Rows Active", "activatedgridAutoRows")}
            {renderSelect(
              "Grid Justify Items Active",
              "activatedjustifyItems",
              ["start", "end", "center", "stretch"]
            )}
            {renderSelect(
              "Grid Justify Content Active",
              "activatedjustifyContent",
              [
                "start",
                "end",
                "center",
                "space-between",
                "space-around",
                "stretch",
              ]
            )}
            {renderSelect(
              "Grid Align Content Active",
              "activatedalignContent",
              [
                "start",
                "end",
                "center",
                "space-between",
                "space-around",
                "stretch",
              ]
            )}
            {renderSelect("Grid Place Items Active", "activatedplaceItems", [
              "start",
              "end",
              "center",
              "stretch",
            ])}
            {renderSelect(
              "Grid Place Content Active",
              "activatedplaceContent",
              [
                "start",
                "end",
                "center",
                "space-between",
                "space-around",
                "stretch",
              ]
            )}
            {renderInput("Grid Column Gap Active", "activatedcolumnGap")}
            {renderInput("Grid Row Gap Active", "activatedrowGap")}
          </>
        )}
        {renderMutableInput("Gap Active", "activatedgap", [
          "0",
          "2rem",
          "2em",
          "10px",
          "2%",
        ])}
        {renderSelect("Visibility Active", "activatedvisibility", [
          "visible",
          "hidden",
          "collapse",
          "inherit",
          "initial",
          "unset",
        ])}

        {renderInput("Color Active", "activatedcolor", "color")}
        {renderInput(
          "Background Color Active",
          "activatedbackgroundColor",
          "color"
        )}
        {renderactivatedBackgroundProperties(
          renderSelect,
          searchTerm,
          handleChange,
          selectedSection
        )}
        {renderActivatedGradientProperties(
          renderSelect,
          searchTerm,
          renderInput,
          selectedSection
        )}

        {renderSelect("Font Family Active", "activatedfontFamily", [
          "Arial",
          "Helvetica",
          "Times New Roman",
          "Courier New",
          "Verdana",
          "Georgia",
          "Palatino",
          "Garamond",
          "Comic Sans MS",
          "Trebuchet MS",
          "Arial Black",
          "Impact",
          "Tahoma",
          "Lucida Sans Unicode",
          "Lucida Grande",
          "Century Gothic",
          "Frank Ruhl",
          "Segoe UI",
          "Gill Sans",
          "Myriad Pro",
          "Futura",
          "Baskerville",
          "Didot",
          "Optima",
          "Caslon",
          "Cambria",
          "Consolas",
          "Menlo",
          "Andale Mono",
          "Inconsolata",
          "Source Sans Pro",
          "Roboto",
          "Open Sans",
          "Lato",
          "Montserrat",
          "Raleway",
          "Oswald",
          "Poppins",
          "Merriweather",
          "PT Sans",
          "Playfair Display",
          "Nunito",
          "Rubik",
          "Josefin Sans",
          "Quicksand",
          "Droid Sans",
          "Noto Sans",
          "Exo 2",
          "Work Sans",
          "Overpass",
          "Alegreya",
          "Bebas Neue",
          "Hind",
          "Anton",
          "Lora",
          "DM Sans",
          "Barlow",
          "Titillium Web",
          "Suisse Int'l",
          "Noto Serif",
          "Tisa",
          "Muli",
          "Arimo",
          "Karla",
          "Zilla Slab",
          "Space Mono",
          "Libre Baskerville",
          "Fira Sans",
          "Archivo Narrow",
          "Varela Round",
          "Oxygen",
          "Catamaran",
          "Cairo",
          "Dosis",
          "Kreon",
          "Bitter",
          "Candal",
          "Averia Serif Libre",
          "Arapey",
          "Hind Guntur",
          "Saira",
          "Titillium",
          "Dancing Script",
          "Satisfy",
          "Raleway Dots",
          "Courgette",
          "Lobster",
          "Pacifico",
          "Shadows Into Light",
          "Sacramento",
          "Rock Salt",
          "Yellowtail",
        ])}
        {renderMutableInput("Font Size Active", "activatedfontSize", [
          "16px",
          "2em",
          "1rem",
          "75%",
          "1vw",
        ])}
        {renderSelect("Font Weight Active", "activatedfontWeight", [
          "normal",
          "bold",
          "100",
          "200",
          "300",
          "400",
          "500",
          "600",
          "700",
          "800",
          "900",
        ])}
        {renderSelect("Font Style Active", "activatedfontStyle", [
          "normal",
          "italic",
          "oblique",
        ])}
        {renderSelect("Font Variant Active", "activatedfontVariant", [
          "normal",
          "small-caps",
        ])}
        {renderInput("Line Height Active", "activatedlineHeight", "text", {
          placeholder: "e.g., 1.5 or 24px",
        })}
        {renderMutableInput("Text Shadow Active", "activatedtextShadow", [
          "none",
          "2px 2px 5px #000000",
        ])}

        {renderSelect("Text Align Active", "activatedtextAlign", [
          "left",
          "center",
          "right",
          "justify",
        ])}
        {renderSelect("Vertical Align Active", "activatedverticalAlign", [
          "baseline",
          "sub",
          "super",
          "top",
          "text-top",
          "middle",
          "bottom",
          "text-bottom",
        ])}
        {renderSelect("Text Decoration Active", "activatedtextDecoration", [
          "none",
          "underline",
          "overline",
          "line-through",
          "underline overline",
        ])}
        {renderSelect("Text Transform Active", "activatedtextTransform", [
          "none",
          "capitalize",
          "uppercase",
          "lowercase",
        ])}
        {renderInput(
          "Letter Spacing Active",
          "activatedletterSpacing",
          "text",
          {
            placeholder: "e.g., 1px or 0.1em",
          }
        )}
        {renderInput("Word Spacing Active", "activatedwordSpacing", "text", {
          placeholder: "e.g., 2px or 0.5em",
        })}
        {renderInput("Text Indent Active", "activatedtextIndent", "text", {
          placeholder: "e.g., 20px or 2em",
        })}
        {renderSelect("White Space Active", "activatedwhiteSpace", [
          "normal",
          "nowrap",
          "pre",
          "pre-line",
          "pre-wrap",
        ])}
        {renderSelect("Text Overflow Active", "activatedtextOverflow", [
          "clip",
          "ellipsis",
          "fade",
        ])}
        {renderSelect("Direction Active", "activateddirection", ["ltr", "rtl"])}
        {renderSelect("Unicode Bidi Active", "activatedunicodeBidi", [
          "normal",
          "embed",
          "bidi-override",
        ])}
        {renderSelect("Writing Mode Active", "activatedwritingMode", [
          "horizontal-tb",
          "vertical-rl",
          "vertical-lr",
        ])}

        {renderSelect("Cursor Active", "activatedcursor", [
          "default",
          "pointer",
          "text",
          "move",
          "wait",
          "help",
          "not-allowed",
          "crosshair",
          "cell",
          "vertical-text",
          "alias",
          "copy",
          "no-drop",
          "grab",
          "grabbing",
          "e-resize",
          "n-resize",
          "ne-resize",
          "nw-resize",
          "s-resize",
          "se-resize",
          "sw-resize",
          "w-resize",
          "ns-resize",
          "ew-resize",
          "nesw-resize",
          "nwse-resize",
          "zoom-in",
          "zoom-out",
          "all-scroll",
        ])}
        {renderSelect("Filter Active", "activatedfilter", [
          "none",
          "blur(5px)",
          "brightness(0.5)",
          "contrast(150%)",
          "drop-shadow(10px 10px 5px grey)",
          "grayscale(100%)",
          "hue-rotate(90deg)",
          "invert(100%)",
          "opacity(50%)",
          "saturate(200%)",
          "sepia(100%)",
        ])}
        {renderSelect("Backdrop Filter Active", "activatedbackdropFilter", [
          "none",
          "blur(5px)",
          "brightness(0.5)",
          "contrast(150%)",
          "drop-shadow(10px 10px 5px grey)",
          "grayscale(100%)",
          "hue-rotate(90deg)",
          "invert(100%)",
          "opacity(50%)",
          "saturate(200%)",
          "sepia(100%)",
        ])}
        {renderSelect("Mix Blend Mode Active", "activatedmixBlendMode", [
          "normal",
          "multiply",
          "screen",
          "overlay",
          "darken",
          "lighten",
          "color-dodge",
          "color-burn",
          "hard-light",
          "soft-light",
          "difference",
          "exclusion",
          "hue",
          "saturation",
          "color",
          "luminosity",
        ])}
        {renderMutableInput("Aspect Ratio Active", "activatedaspectRatio", [
          "auto",
          "1 / 1",
          "4 / 3",
          "16 / 9",
          "21 / 9",
          "3 / 2",
          "8.5 / 11",
          "11 / 8.5",
          "A4",
          "custom",
        ])}
        {renderMutableInput("Transform Active", "activatedtransform", [
          "none",
          "translate(100px, 200px)",
          "translateX(100px)",
          "translateY(200px)",
          "scale(1.5, 1.6)",
          "scaleX(1.5)",
          "scaleY(1.6)",
          "rotate(30deg)",
          "skew(30deg, 10deg)",
          "skewX(30deg)",
          "skewY(10deg)",
          "matrix(1, 0.5, -0.5, 1, 100, 200)",
        ])}
        {renderMutableInput(
          "Transition Timing Function Active",
          "activatedtransition",
          [
            "none",
            "ease 3s",
            "linear 3s",
            "ease-in 3s",
            "ease-out 3s",
            "ease-in-out 3s",
            "cubic-bezier(0.25, 0.1, 0.25, 1.0)",
          ]
        )}
      </>
    ),
  ];

  return (
    <div>
      {allInputs.map((items, index) => (
        <div key={index}>{items}</div>
      ))}
    </div>
  );
};

const styles = {
  container: {
    padding: "5px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    backgroundColor: "#f9f9f9",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    maxWidth: "400px",
    margin: "20px auto",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    overflow: "hidden",
  },
  heading: {
    fontSize: "15px",
    marginBottom: "10px",
    color: "#333",
    borderBottom: "1px solid #ddd",
    paddingBottom: "5px",
  },
  inputGroup: {
    marginBottom: "10px",
  },
  label: {
    display: "block",
    marginBottom: "5px",
    fontWeight: "bold",
    color: "#555",
  },
  input: {
    width: "100%",
    padding: "3px 5px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },
  select: {
    width: "100%",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    boxSizing: "border-box",
  },
  animationButton: {
    width: "100%",
    padding: "10px",
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  button: {
    marginTop: "5px",
    padding: "8px",
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
};

export default SectionProperties;
